import { CustomTypographyComponentProps } from "../types";
import { Typography } from "@mui/material";

export const H5Typography = ({
  children,
  ...props
}: CustomTypographyComponentProps) => {
  return (
    <Typography variant="h5" {...props}>
      {children}
    </Typography>
  );
};
